import { MutationTree } from 'vuex';
import { IEntry } from '../types/entry';
import { EDocumentChangelogMutation } from './document-changelog.constants';
import { IDocumentChangelogState } from './document-changelog.types';

export const mutations: MutationTree<IDocumentChangelogState> = {
  [EDocumentChangelogMutation.AddEntry](
    state: IDocumentChangelogState,
    { documentId, entry }: { documentId: string; entry: IEntry }
  ) {
    state.posts = {
      ...state.posts,
      [documentId]: [...(state.posts[documentId] || []), entry],
    };
  },
  [EDocumentChangelogMutation.DeletePost](state: IDocumentChangelogState, documentId: string) {
    const newPosts = { ...state.posts };
    delete newPosts[documentId];
    state.posts = newPosts;
  },
};
